import { render, staticRenderFns } from "./logindismRy.vue?vue&type=template&id=528ff13e&scoped=true"
import script from "./logindismRy.vue?vue&type=script&lang=js"
export * from "./logindismRy.vue?vue&type=script&lang=js"
import style0 from "./logindismRy.vue?vue&type=style&index=0&id=528ff13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ff13e",
  null
  
)

export default component.exports